import ScoringInspector from './ScoringInspector'

export default ScoringInspector
